export const addedSuccessfully = "La nouvelle plage d'impressions a été ajoutée avec succès";
export const tryAddAgain = "Le plage d'impressions n'a pas été ajouté. Une erreur s'est produite, veuillez réessayer.";

export const updatedSuccessfully = "Le prix a été mis à jour avec succès";
export const tryUpdateAgain = "Le prix n'a pas été ajouté. Une erreur s'est produite, veuillez réessayer.";